// See web/app/themes/jcf-theme/templates/base.twig

export default () => {
  var button = document.getElementById("mobile__nav--button");
  var mNav = document.getElementById("nav-mobile");
  // let open = sessionStorage.getItem('data-open');

  // if (open) {
  //   mNav.setAttribute('data-open', '' );
  //   mNav.setAttribute('data-animate', false );
  // }

  if (!button) return;

  button.addEventListener(
    "click",
    function () {
      // mNav.removeAttribute('data-animate');
      if (mNav.hasAttribute("data-open")) {
        mNav.removeAttribute("data-open");
        document.documentElement.classList.remove("navopen");
        // sessionStorage.removeItem('data-open');
      } else {
        mNav.setAttribute("data-open", "");
        document.documentElement.classList.add("navopen");
        // sessionStorage.setItem('data-open', true);
      }
    },
    false,
  );
};
